import React, { useEffect, useRef, useState, useCallback } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Accordion, AccordionTab } from "primereact/accordion";
import "primeicons/primeicons.css";
import { ApiEndpoints, Constants } from "../../constants/appConstants";
import { useLocation, useSearchParams } from "react-router";
import httpService from "../../services/httpService";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
//import { useNavigate } from 'react-router';
import "./ProviderProfileComponent.scss";
import { Tooltip } from "primereact/tooltip";
import { Badge } from "primereact/badge";
import {
  alphaNumericSort,
  PerformanceArea,
  ReviewRquest,
  Standard,
  TierQuestions,
  Status,
  ReviewStatusCode,
  Comment,
  ReviewType,
  TierCode,
  ProviderType,
  ReviewState,
} from "./models";
import StandardsDetailsComponent from "./StandardsDetailsComponent";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { useAuthContext } from "../../Context/AuthContext";
import CommentsSidebar from "./CommentsSidebar";
import { useAppContext } from "../../Context";
import MultipartFileUploadComponent from "../FileUpload/MultpartFileUploadComponent";
import CommonDialogWindowComponent from "../CommonDialogWindowComponent/CommonDialogWindowComponent";
import ReviewersDetailsComponent from "./ReviwersDetailsComponent";

const ScoProviderProfileComponent: React.FC<{ reviewYear?: number }> = ({ reviewYear: propReviewYear }) => {
  //const navigate = useNavigate()
  const { appUser, isAdministrator, isFinalReviewer, isSmeReviewer } =
    useAuthContext();
  const [uploadStatus, setUploadStatus] = useState<string | null>(null);
  const location = useLocation();
  const [provider, setSelectedProvider] = useState<any>({});
  //const [providerDetails, setProviderDetails] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [fileUploaded, setFileUploaded] = useState<boolean>(false); // New state to track file upload status
  //const [activeIndex] = useState<number[]>([0, 1, 2]);
  const [status, setStatus] = useState<Status[]>([]);
  const [performanceAreas, setPerformanceAreas] = useState<PerformanceArea[]>(
    []
  ); // New state to hold performance areas
  const [visible, setVisible] = useState(false);
  const [reviweResponses, setReviewResponses] = useState<ReviewRquest[]>([]);
  const [calculatedTier, setCalculatedTier] = useState<string>();
  const [isCalculate, setIsCalculate] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<
    Status | null | undefined
  >(null);
  const [isActiveReview, setIsActiveReview] = useState(false);
  const [isActiveDisputeReview, setIsActiveDisputeReview] = useState(false);
  const [appliedTierId, setAppliedTierId] = useState<number>(0);
  const [allStatues, setAllStatues] = useState<Status[]>([]);
  const [isStatusLoaded, setIsStatusLoaded] = useState<boolean>(false);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [commentProviderMPI, setCommentProviderMPI] = useState(
    location?.state?.provider?.mpi
  );
  const [commentMeasureNumber, setCommentMeasureNumber] = useState("");
  const [commentMeasureId, setCommentMeasureId] = useState(0);
  const [commentLevel, setCommentLevel] = useState("");
  const [providerId, setProviderId] = useState(0);
  const [allCommentData, setAllCommentData] = useState<Comment[]>([]);
  const { reviewYear: contextReviewYear } = useAppContext();
  const reviewYear = propReviewYear ?? contextReviewYear;
  const [searchParams] = useSearchParams();
  const [providerAdditionalInfo, setProviderAdditionalInfo] = useState<any>({});
  const [statusesByRole, setStatusesByRole] = useState<any[]>([]);
  const [measureEvaluationStatuses, setMeasureEvaluationStatuses] = useState<
    any[]
  >([]);
  const [reviewers, setReviewers] = useState<any[]>([]);
  const [canReview, setCanReview] = useState<boolean>(false);
  const [canStartReview, setCanStartReview] = useState<boolean>(false);
  // Reference variable for Dialog component
  const dialogRef = useRef<any>(null);
  // Reference variable for Toast component
  const toast = useRef<Toast>(null);
  // const [reviewReasons,setReviewReasons]=useState<any[]>();

  const [changingStatus, setChangingStatus] = useState<boolean>(false);
  const [updatingStatus, setUpdatingStatus] = useState<boolean>(false);

  useEffect(() => {
    getMeasureEvaluationStatuses();
    return () => {
      if (dialogRef.current) {
        dialogRef.current = null;
      }
    };
  }, []);

  const getMeasureEvaluationStatuses = () => {
    httpService
      .get(
        `${ApiEndpoints.GetMeasureEvaluationStatuses}?providerType=${ProviderType.SCO}`
      )
      .then((response: any) => {
        if (response.status === 200) {
          setMeasureEvaluationStatuses(response.data);
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      });
  };

  useEffect(() => {
    if (canReview && reviewers && reviewers.length > 0) {
      let canStart = false;
      if (
        provider &&
        ![
          ReviewStatusCode.ScoNotStarted?.toLowerCase(),
          ReviewStatusCode.NotStarted?.toLowerCase(),
          ReviewStatusCode.ScoResolutionNotStarted?.toLowerCase()
        ].includes(provider.reviewStatusCode?.toLowerCase()) &&
        reviewers?.length > 0 &&
        statusesByRole.includes(provider.reviewStatusCode)
      ) {
        canStart = reviewers.some(
          (r: any) =>
            r.reviewStatusCode?.toLowerCase() ===
              provider.reviewStatusCode?.toLowerCase() &&
            (!r.reviewState ||
              r.reviewState?.toLowerCase() ===
                ReviewState.NOTSTART?.toLowerCase())
        );
      }

      setCanStartReview(canStart);
    }
  }, [provider, canReview, reviewers]);

  // Initialize provider from location
  useEffect(() => {
    const mpiId = searchParams.get("mpi");
    if (reviewYear && !mpiId) {
      const _provider = location.state?.provider;
      if (_provider) {
        console.log("Provider:", _provider);
        fetchProviderDetails(_provider?.mpi);
        fetchAllCommentsForProvider(_provider?.mpi);
        setProviderId(_provider?.providerId);
        setCommentProviderMPI(_provider?.mpi);
        setCommentMeasureNumber(_provider?.mpi);
        getProviderAdditionalInfo(_provider?.mpi);
        setCommentMeasureId(0);
        setCommentLevel("provider");
        fetchStatusesByUser();
        getReviewersDetails(_provider?.mpi);
        canHaveAccessToReview(_provider?.mpi);
        //fetchProviderAttestationFileDetails(_provider?.mpi);
        // fetchPerformanceStandardsMeasuresInfo(
        //   _provider?.mpi,
        //   _provider?.appliedTier
        // );
      } // Fetch performance areas and related data
    }
  }, [location.state?.provider, reviewYear]);

  useEffect(() => {
    const mpiId = searchParams.get("mpi");

    if (reviewYear && mpiId) {
      const mpi = Number(mpiId);
      fetchProviderDetails(mpi);
      fetchAllCommentsForProvider(mpiId);
      setCommentProviderMPI(mpiId);
      setCommentMeasureNumber(mpiId);
      setCommentMeasureId(0);
      fetchStatusesByUser();
      setCommentLevel("provider");
    } // Fetch performance areas and related data
  }, [location.state?.provider, reviewYear]);

  const fetchStatusesByUser = () => {
    httpService
      .get(`${ApiEndpoints.GetStatusesByRole}?providerType=${ProviderType.SCO}`)
      .then((response: any) => {
        if (response.status === 200) {
          setStatusesByRole(response.data);
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      });
  };

  useEffect(() => {
    if (provider) {
      setProviderId(provider?.providerId);

      fetchPerformanceStandardsMeasuresInfo(
        provider?.mpi,
        provider?.appliedTierCode
      );
    }
  }, [provider]);

  //onload events

  useEffect(() => {
    isActiveReviewCycle();
    isActiveDisputeReviewCycle();
    getAllStatus();
  }, []);

  useEffect(() => {
    if (provider.providerId && isStatusLoaded && !isActiveDisputeReview) {
      updateStatusDropDown();
      setSelectedStatus(getSelectedStatus(provider.reviewStatus));
    }
    else if(provider.providerId && isStatusLoaded && isActiveDisputeReview){
      updateStatusDropDownForDispute();
      setSelectedStatus(getSelectedStatus(provider.reviewStatus));
    }
  }, [provider, isStatusLoaded,isActiveDisputeReview]);

  useEffect(() => {
    if (
      appUser &&
      (isSmeReviewer() || isAdministrator()) &&
      provider &&
      reviewers &&
      reviewers.length > 0 &&
      ((isActiveDisputeReview && provider?.reviewStatusCode?.toLowerCase() !==
        ReviewStatusCode.ScoResolutionReviewCompleted.toLowerCase()) || provider?.reviewStatusCode?.toLowerCase() !==
        ReviewStatusCode.ScoReviewCompleted.toLowerCase())
    ) {
      if (
        (isActiveDisputeReview && provider?.reviewStatusCode?.toLowerCase() !==
        ReviewStatusCode.ScoResolutionFinalReview.toLowerCase()  ) || 
        provider?.reviewStatusCode?.toLowerCase() !==
        ReviewStatusCode.ScoFinalReview.toLowerCase()
      ) {
        changeStatusToFinalReview();
      }
    }
  }, [performanceAreas, changingStatus]);

  useEffect(() => {
    if (providerId > 0) {
      updatePerformanceAreasForComments(0, true);
    }
  }, [allCommentData,  performanceAreas]);

  useEffect(() => {
    if (
      appUser &&
      (isFinalReviewer() || isAdministrator()) &&
      provider &&
      reviewers &&
      reviewers.length > 0 &&
      ![ReviewStatusCode.ScoResolutionReviewCompleted.toLowerCase(),ReviewStatusCode.ScoReviewCompleted.toLowerCase(),ReviewStatusCode.ScoSMEReview.toLowerCase()].includes(provider?.reviewStatusCode?.toLowerCase())
    ) {
      // get the final reviewer details
      const finalReview = reviewers.find(
        (r: any) =>
          r.reviewStatusCode?.toLowerCase() ===
          provider?.reviewStatusCode?.toLowerCase()
      );
      if (
        finalReview?.reviewState?.toLowerCase() !==
          ReviewState.NOTSTART?.toLowerCase() &&
        finalReview?.reviewerName?.toLowerCase() ===
          appUser?.name?.toLowerCase()
      ) {
        calculate(true);
      }
    }
  }, [appUser, provider, reviewers]);

  useEffect(() => {
    if (allStatues && allStatues.length > 0) {
      if (status && status.length > 0) handleRequiredStatusOption();
    }
  }, [status]);

  const canHaveAccessToReview = (mpi: string) => {
    if (!mpi) {
      return;
    }
    httpService
      .get(`${ApiEndpoints.CanHaveAccessToReview}/${reviewYear}/${mpi}`)
      .then((response: any) => {
        if (response.status === 200) {
          setCanReview(response.data);
          console.log("reviewers");
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      });
  };

  const getReviewersDetails = (mpi: string) => {
    if (!mpi) {
      return;
    }
    httpService
      .get(`${ApiEndpoints.GetReviewersDetailsByMpi}/${reviewYear}/${mpi}`)
      .then((response: any) => {
        if (response.status === 200) {
          setReviewers(response.data);
          console.log("reviewers");
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      });
  };

  const getProviderAdditionalInfo = (providerMpi: string) => {
    httpService
      .get(
        `${ApiEndpoints.GetProviderAdditionalInfo}/${reviewYear}/${providerMpi}`
      )
      .then((response: any) => {
        if (response.status === 200) {
          setProviderAdditionalInfo(response.data);
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      });
  };

  const updatePerformanceAreasForComments = (
    measureId: number,
    isCommentsLoaded: boolean = false
  ) => {
    if (performanceAreas.length > 0 && measureId > 0) {
      setPerformanceAreas((prevPerformanceAreas) =>
        prevPerformanceAreas.map((area) => ({
          ...area,
          standards: area.standards.map((standard) => ({
            ...standard,
            measures: standard.measures.map((measure) => {
              if (measure.measureId === measureId) {
                // Update measure.isCommentsAvailable
                return { ...measure, isCommentsAvailable: true };
              }
              return measure; // No match, return the original measure
            }),
          })),
        }))
      );
    } else if (isCommentsLoaded) {
      setPerformanceAreas((prevPerformanceAreas) =>
        prevPerformanceAreas.map((area) => ({
          ...area,
          standards: area.standards.map((standard) => ({
            ...standard,
            measures: standard.measures.map((measure) => {
              if (
                allCommentData.some((x) => x.measureId == measure.measureId)
              ) {
                // Update measure.isCommentsAvailable
                return { ...measure, isCommentsAvailable: true };
              }
              return measure; // No match, return the original measure
            }),
          })),
        }))
      );
    }
  };

  const isActiveReviewCycle = () => {
    httpService
      .get(`${ApiEndpoints.IsActiveReview}/${ProviderType.SCO}`)
      .then((response: any) => {
        setIsActiveReview(response?.data);
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      });
  };

  const isActiveDisputeReviewCycle = () => {
    httpService
      .get(`${ApiEndpoints.IsActiveDisputeCycle}/${ProviderType.SCO}`)
      .then((response: any) => {
        setIsActiveDisputeReview(response?.data);
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      });
  };

  const hasAnySMEReviewForMeasure = (): boolean => {
    return performanceAreas.some((area) =>
      area.standards.some((standard) =>
        standard.measures.some(
          (measure) =>
            measure.reviewResponse &&
            measure.reviewResponse?.toLowerCase() === "sme"
        )
      )
    );
  };
  const canDisableStatusRelatedInputs = useCallback(() => {
    const hasValidStatus =
      selectedStatus &&
      statusesByRole.some(
        (s) => s?.toLowerCase() == selectedStatus.statusCode?.toLowerCase()
      );
    return !canReview || canStartReview || !hasValidStatus;
  }, [selectedStatus, statusesByRole, canReview, canStartReview]);
  // Fetch files and provider details once provider is set

  const updateStatusDropDown = () => {
    let requiredStatuses: Status[];
    if (
      provider.reviewStatusCode?.toLowerCase() ===
        ReviewStatusCode.NotStarted?.toLowerCase() ||
      provider.reviewStatusCode?.toLowerCase() ===
        ReviewStatusCode.ScoNotStarted?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoNotStarted.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoInitialReview.toLowerCase()
      );
    } else if (
      provider.reviewStatusCode?.toLowerCase() ===
      ReviewStatusCode.ScoInitialReview?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoInitialReview.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoFinalReview.toLowerCase()
      );
    } else if (
      provider.reviewStatusCode?.toLowerCase() ===
      ReviewStatusCode.ScoSMEReview?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoSMEReview.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoFinalReview.toLowerCase()
      );
    } else if (
      provider.reviewStatusCode?.toLowerCase() ===
      ReviewStatusCode.ScoFinalReview?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoFinalReview.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoReviewCompleted.toLowerCase()
      );
    } else {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
          ReviewStatusCode.ScoReviewCompleted.toLowerCase()
      );
    }
    // if (hasUnReviewedMeasures()) {
    //   requiredStatuses = requiredStatuses.filter(
    //     (s) => s.statusCode?.toLowerCase() !== ReviewStatusCode.ScoReviewCompleted.toLowerCase()
    //   );
    // }

    setStatus(requiredStatuses);
    return requiredStatuses;
  };

    const updateStatusDropDownForDispute = () => {
    let requiredStatuses: Status[];
    if (
      provider.reviewStatusCode?.toLowerCase() ===
        ReviewStatusCode.ScoResolutionNotStarted?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoResolutionNotStarted.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoResolutionInitialReview.toLowerCase()
      );
    } else if (
      provider.reviewStatusCode?.toLowerCase() ===
      ReviewStatusCode.ScoResolutionInitialReview?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoResolutionInitialReview.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoResolutionFinalReview.toLowerCase()
      );
    } else if (
      provider.reviewStatusCode?.toLowerCase() ===
      ReviewStatusCode.ScoResolutionSMEReview?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoResolutionSMEReview.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoResolutionFinalReview.toLowerCase()
      );
    } else if (
      provider.reviewStatusCode?.toLowerCase() ===
      ReviewStatusCode.ScoResolutionFinalReview?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoResolutionFinalReview.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoResolutionReviewCompleted.toLowerCase()
      );
    } else {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
          ReviewStatusCode.ScoResolutionReviewCompleted.toLowerCase()
      );
    }
    // if (hasUnReviewedMeasures()) {
    //   requiredStatuses = requiredStatuses.filter(
    //     (s) => s.statusCode?.toLowerCase() !== ReviewStatusCode.ScoReviewCompleted.toLowerCase()
    //   );
    // }

    setStatus(requiredStatuses);
    return requiredStatuses;
  };
  const getAllStatus = () => {
    httpService
      .get<Status[]>(
        `${ApiEndpoints.GetStatus}?providerType=${Constants.SCOKey}`
      )
      .then((response) => {
        setAllStatues(response.data);
        setIsStatusLoaded(true);
      })
      .catch((error) => {
        console.error("Error fetching tiers:", error);
      });
  };

  const updateStatus = (e: Status) => {
    setUpdatingStatus(true); // Start loading
    httpService
      .post(ApiEndpoints.SetReviewStatus, {
        ProviderId: provider.providerId,
        StatusId: e.statusId,
        reviewerName: appUser?.name ?? appUser?.email,
        ReviewYear: reviewYear,
        MpiId: provider.mpi,
        providerType: ProviderType.SCO,
      })
      .then((response: any) => {
        if (response.status === 200) {
          setSelectedStatus(e);
          setChangingStatus(false);
          //setProviderDetails({ ...provider, reviewStatus: e.statusName })
          console.log("allStatues:", allStatues);
          getReviewersDetails(provider.mpi);
          let currentReviewType =
            e.statusCode.toUpperCase() === ReviewStatusCode.InPrimaryReview
              ? ReviewType.PrimaryReview
              : e.statusCode.toUpperCase() === ReviewStatusCode.InPeerReview
              ? ReviewType.SecondaryReview
              : provider.reviewType;

          setSelectedProvider({
            ...provider,
            reviewStatusCode: e.statusCode,
            reviewStatus: e.statusName,
            reviewStatusId: e.statusId,
            reviewType: currentReviewType,
          });
          // Invoking ReviewStatusSync in Intake Portal - configurable via environment variable
          if (Constants.IS_REALTIME_REVIEW_STATUS_SYNC_ENABLED) {
            // syncReviewStatusInIntakePortal(e.statusId);
          }
          
          // Show success toast
          toast.current?.show({ 
            severity: 'success', 
            summary: 'Success', 
            detail: `Status updated to ${e.statusName} successfully`, 
            life: 3000 
          });
        }
      })
      .catch((error: any) => {
        console.error("Error updating status:", error);
        // Show error toast
        toast.current?.show({ 
          severity: 'error', 
          summary: 'Error', 
          detail: 'Failed to update status. Please try again.', 
          life: 3000 
        });
      })
      .finally(() => {
        setUpdatingStatus(false); // Stop loading
      });
  };

  //flip to final review

  const changeStatusToFinalReview = () => {
    if (
      allStatues &&
      allStatues.length > 0 &&
      performanceAreas &&
      performanceAreas.length > 0
    ) {
      const requiredFinalStatus = isActiveDisputeReview?ReviewStatusCode.ScoResolutionFinalReview.toLowerCase():ReviewStatusCode.ScoFinalReview.toLowerCase()
      const finalReviewStatus = allStatues.find(
        (s) =>
          s.statusCode?.toLowerCase() ===
          requiredFinalStatus
      );
      if (!hasUnReviewedMeasures() && !hasAnySMEReviewForMeasure()) {
        if ((isSmeReviewer() || isAdministrator()) && finalReviewStatus && changingStatus) {
          if (
            provider && (isActiveDisputeReview && provider.reviewStatusCode?.toLowerCase() !==
        ReviewStatusCode.ScoResolutionFinalReview.toLowerCase()) ||
            provider.reviewStatusCode?.toLowerCase() !==
              ReviewStatusCode.ScoFinalReview.toLowerCase()
          ) {
            // Ensure only one API call happens by checking and resetting changingStatus before calling updateStatus
            if (
              provider &&
              (isActiveDisputeReview && provider.reviewStatusCode?.toLowerCase() !==
              ReviewStatusCode.ScoResolutionFinalReview.toLowerCase()) ||
              provider.reviewStatusCode?.toLowerCase() !==
              ReviewStatusCode.ScoFinalReview.toLowerCase() &&
              changingStatus
            ) {
              setChangingStatus(false); // Reset before API call to prevent duplicate calls
              updateStatus(finalReviewStatus);
            }
            setChangingStatus(false);
          }
        }
      }
    }
  };

  const setReviewStatus = (e: Status) => {
    const getStatusChangeAlertConfig = (e: any) => {
      let commonConfig = {
        open: true,
        title: "Confirm Status Change",
        message: `Are you sure you want to change the status to "${e.statusName}"?`,
        onClose: (result: boolean) => {
          if (result) {
            updateStatus(e);
          }
          dialogRef.current.setDialogConfig(undefined);
        },
      };

      if (
        e.statusCode?.toLowerCase() ===
        ReviewStatusCode.ScoSMEReview.toLowerCase() || e.statusCode?.toLowerCase() ===
        ReviewStatusCode.ScoResolutionSMEReview.toLowerCase()
      ) {
        if (hasUnReviewedMeasures()) {
          return {
            open: true,
            hideNo: true,
            yesButtonLabel: "Ok",
            title: "Review Pending",
            message:
              "All measures must be reviewed before moving to SME Review.",
            onClose: () => {
              dialogRef.current.setDialogConfig(undefined);
            },
          };
        }
      }
      if (
        e.statusCode?.toLowerCase() ===
        ReviewStatusCode.ScoFinalReview.toLowerCase() || e.statusCode?.toLowerCase() ===
        ReviewStatusCode.ScoResolutionFinalReview.toLowerCase()
      ) {
        if (hasAnySMEReviewForMeasure()) {
          return {
            open: true,
            hideNo: true,
            yesButtonLabel: "Ok",
            title: "SME Review Pending",
            message:
              "Some measures are pending SME review. You cannot move to Final Review until all SME reviews are completed.",
            onClose: () => {
              dialogRef.current.setDialogConfig(undefined);
            },
          };
        }

        if (hasUnReviewedMeasures()) {
          return {
            open: true,
            hideNo: true,
            yesButtonLabel: "Ok",
            title: "Review Pending",
            message:
              "All measures must be reviewed before moving to Final Review.",
            onClose: () => {
              dialogRef.current.setDialogConfig(undefined);
            },
          };
        }
      }

      if (
        e.statusCode?.toLowerCase() ===
        ReviewStatusCode.ScoReviewCompleted.toLowerCase() || e.statusCode?.toLowerCase() ===
        ReviewStatusCode.ScoResolutionReviewCompleted.toLowerCase()
      ) {
        if (
          hasUnReviewedMeasures() ||
          (!calculatedTier &&
            provider.currentTierCode?.toLowerCase() ===
              TierCode.UnAssigned.toLowerCase())
        ) {
          return {
            open: true,
            hideNo: true,
            yesButtonLabel: "Ok",
            title: hasUnReviewedMeasures()
              ? "Unreviewed Measures Present"
              : "Unassigned Tier",
            message: hasUnReviewedMeasures()
              ? "There are some unreviewed measures, so you cannot mark this as review complete."
              : `You cannot change the status to "${e.statusName}" while the provider is in the Unassigned tier.`,
            onClose: () => {
              dialogRef.current.setDialogConfig(undefined);
            },
          };
        }
      }
      return commonConfig;
    };

    if (dialogRef.current) {
      let config = getStatusChangeAlertConfig(e);
      dialogRef.current.setDialogConfig(config);
    }
  };
    // const syncReviewStatusInIntakePortal = (statusId: any) => {
  //   httpService
  //     .post(ApiEndpoints.SyncProviderStatusWithIntake, {
  //       ProviderId: provider.providerId,
  //       StatusId: statusId,
  //       reviewerEmail: appUser?.email ?? appUser?.name,
  //       MpiId: provider.mpi,
  //     })
  //     .then((response: any) => {
  //       if (response.status === 200) {
  //         console.log("allStatues:", allStatues);
  //         console.log("syncReviewStatusInIntakePortal Response:", response);
  //       }
  //     });
  // };

  // Fetch file information after file is uploaded
  useEffect(() => {
    if (fileUploaded) {
      //fetchSupportingFileInfo();
      setFileUploaded(false); // Reset after fetching
    }
  }, [fileUploaded]); // Triggers when a file is uploaded

  const fetchProviderDetails = async (mpi: number) => {
    httpService
      .get(`${ApiEndpoints.GetProviderDetails}/${reviewYear}/${mpi}`)
      .then((response: any) => {
        let _provider = response.data;
        console.log("Provider:", _provider);
        setSelectedProvider(_provider);
        setSelectedStatus(getSelectedStatus(_provider.reviewStatus));
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      })
      .finally(() => {
        // console.log('Finally');
      });
  };

  const getSelectedStatus = (statusName: string) => {
    if (allStatues && allStatues.length > 0) {
      return (
        allStatues.find(
          (status) =>
            status.statusName?.toLowerCase() === statusName?.toLowerCase()
        ) || null
      );
    }
    return undefined;
  };

  const fetchAllCommentsForProvider = async (providerId: string) => {
    httpService
      .post(ApiEndpoints.GetAllCommentsForProvider, {
        commentLevel: commentLevel,
        providerMPI: providerId,
        measureId: commentMeasureId,
        reviewYear: reviewYear,
        providerType: ProviderType.SCO
      })
      .then((response: any) => {
        if (response.status === 200) {
          setAllCommentData(response?.data);
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      })
      .finally(() => {
        // console.log('Finally');
      });
  };
  const updatePerformanceAreasStatus = (response: {
    reviewResponseId: number | null | undefined;
    performanceareaId: number;
    standardId: number;
    measureId: number;
    questionId: number;
    reviewResponse: string | null;
    reasons: any[];
    userReason: string;
  }) => {
    if (performanceAreas.length > 0) {
      setPerformanceAreas((prevPerformanceAreas) =>
        prevPerformanceAreas.map((area) => ({
          ...area,
          standards: area.standards.map((standard) => ({
            ...standard,
            measures: standard.measures.map((measure) => {
              if (measure.measureId === response.measureId) {
                if (!response.questionId) {
                  // Update measure.isApproved
                  return {
                    ...measure,
                    reviewResponse: response.reviewResponse,
                    hasReasons:
                      (response.reasons && response.reasons.length > 0) ||
                      !!response.userReason,
                  };
                } else {
                  // Update question.isReviewed
                  return {
                    ...measure,
                    questions: measure.questions.map((question) =>
                      question.questionId === response.questionId
                        ? {
                            ...question,
                            reviewResponse: response.reviewResponse,
                          }
                        : question
                    ),
                  };
                }
              }
              return measure; // No match, return the original measure
            }),
          })),
        }))
      );
    }
  };

  // handling tier response submission
  const onReviewChange = (response: {
    reviewResponseId: number | null | undefined;
    performanceareaId: number;
    standardId: number;
    measureId: number;
    questionId: number;
    reviewResponse: string;
    reasons: any[];
    userReason: string;
  }) => {
    updatePerformanceAreasStatus(response);
    let reviewResponse = reviweResponses.find(
      (resp) =>
        resp.measureId === response.measureId &&
        resp.questionId === response.questionId
    );
    //handling the response data
    if (reviewResponse) {
      reviewResponse.reviewResponse = response.reviewResponse;
      reviewResponse.reasons = response.reasons;
      reviewResponse.userReason = response.userReason;
    } else {
      reviweResponses.push({
        tierId: performanceAreas[0].standards[0].tierId,
        reviewResponseId: response.reviewResponseId,
        mpiId: provider.mpi,
        measureId: response.measureId,
        questionId: response.questionId,
        reviewResponse: response.reviewResponse,
        reasons: response.reasons,
        userReason: response.userReason,
      });
    }
    const requeredData = reviweResponses; //.filter(resp => resp.isApproved || resp.reviewResponseId);
    setReviewResponses(requeredData);
    saveReviewResponses();
  };

  const handleRequiredStatusOption = () => {
    let requiredStatuses = isActiveDisputeReview?updateStatusDropDownForDispute():updateStatusDropDown();
    const smeStatusCode = isActiveDisputeReview ?ReviewStatusCode.ScoResolutionSMEReview.toLowerCase():ReviewStatusCode.ScoSMEReview.toLowerCase();
    const hasSMEReview = hasAnySMEReviewForMeasure();

    if (hasSMEReview) {
      if (
        !requiredStatuses.some(
          (s) => s.statusCode?.toLowerCase() === smeStatusCode
        )
      ) {
        const smeStatus = allStatues.find(
          (s) => s.statusCode?.toLowerCase() === smeStatusCode
        );
        if (smeStatus) requiredStatuses.push(smeStatus);
      }
    } else if (hasUnReviewedMeasures()) {
      requiredStatuses = requiredStatuses.filter(
        (s) =>
          s.statusCode?.toLowerCase() !==
          ReviewStatusCode.ScoReviewCompleted.toLowerCase()
      );
    } else {
      requiredStatuses = requiredStatuses.filter(
        (s) => s.statusCode?.toLowerCase() !== smeStatusCode
      );
    }

    setStatus(requiredStatuses);
  };

  const saveReviewResponses = () => {
    httpService
      .post(
        `${ApiEndpoints.SavePerformanceEvaluation}/${appliedTierId}/${provider.mpi}/${ProviderType.SCO}`,
        reviweResponses
      )
      .then((response) => {
        console.log("Review Response submitted successfully:", response);
        if (isSmeReviewer() || isAdministrator()) {
          setChangingStatus(true);
          getReviewersDetails(provider.mpi);
        }
        calculate(false);
      })
      .catch((error) => {
        console.error("Error submitting review response:", error);
      });
  };

  const calculate = (isOnload: boolean) => {
    if (
      provider?.reviewStatusCode?.toLowerCase() !==
      ReviewStatusCode.ScoReviewCompleted.toLowerCase() && provider?.reviewStatusCode?.toLowerCase() !==
        ReviewStatusCode.ScoSMEReview.toLowerCase()
    ) {
      if (
        (isFinalReviewer() || isAdministrator()) &&
        (isOnload ||
          (performanceAreas &&
            performanceAreas.length > 0 &&
            reviewers &&
            reviewers.length > 0))
      ) {
        const finalReview = reviewers.find(
          (r: any) =>
            r.reviewStatusCode?.toLowerCase() ===
            provider.reviewStatusCode?.toLowerCase()
        );
        if (
          !hasUnReviewedMeasures() &&
          finalReview &&
          finalReview.reviewState?.toLowerCase() !==
            ReviewState.NOTSTART?.toLowerCase() &&
          finalReview.reviewerName?.toLowerCase() ===
            appUser?.name?.toLowerCase()
        ) {
          setIsCalculate(true);
          calculateTier();
        }
      }
    } else {
      setIsCalculate(false);
    }
  };

  const calculateTier = () => {
    //if (reviweResponses.length > 0) {
    httpService
      .post(
        `${ApiEndpoints.SubmitPerformanceEvaluation}/${provider.providerId}/${appliedTierId}/${provider.mpi}?providerType=${Constants.SCOKey}`,
        reviweResponses
      )
      .then((response: any) => {
        console.log("response", response.data);
        setCalculatedTier(response.data);
        setIsCalculate(false);
      })
      .catch(() => {
        //if (dialogRef.current) {
        // dialogRef.current.setDialogConfig({
        //   open: true,
        //   title: "Tier Calculation Failed",
        //   message: "Error While calculating the Tier",
        //   hideNo: true,
        //   yesButtonLabel: "Ok",
        //   onClose: () => {
        //     dialogRef.current.setDialogConfig(undefined);
        //   },
        // });
        //}
        setIsCalculate(false);
        console.error("Error While calculating the Tier");
      });
  };

  const getFilenameFromContentDisposition = (contentDisposition: string) => {
    if (!contentDisposition) {
      return "";
    }
    const matches = contentDisposition.match(
      /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i
    );
    if (matches && matches[1]) {
      const decoded = decodeURIComponent(matches[1]);
      // Strip path separators and characters dangerous in HTML attributes;
      // control chars (charCode 0-31) removed via charCodeAt to avoid no-control-regex lint rule
      return decoded
        .replace(/[/\\?%*:|"<>]/g, "")
        .split("")
        .filter((c) => c.charCodeAt(0) > 31)
        .join("")
        .trim();
    }
    return "";
  };

  const downLoadProviderDataByDataSource = (dataSource: string) => {
    const safeMpi = Number(provider.mpi);
    if (!safeMpi || !Number.isInteger(safeMpi) || safeMpi <= 0) {
      console.error("Invalid MPI value");
      return;
    }
    httpService
      .getBlob(
        `${ApiEndpoints.ExtractDataByDataSource}/${safeMpi}/${encodeURIComponent(dataSource)}?reviewYear=${encodeURIComponent(String(reviewYear))}`
      )
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        const contentDisposition =
          response.headers["content-disposition"] ?? "";
        link.setAttribute(
          "download",
          getFilenameFromContentDisposition(contentDisposition)
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error: any) => {
        setShowConfirmDialog(true);
        console.error("Error downloading provider data:", error);
      });
  };

  // Fetch performance areas, standards, measures, questions, and documents
  const fetchPerformanceStandardsMeasuresInfo = async (
    mpiId: number,
    providerAppliedTier: string
  ) => {
    try {
      if (!mpiId || !providerAppliedTier) {
        setLoading(false);
        return;
      }
      setLoading(true);
      const performanceAreaUrl = isActiveDisputeReview?ApiEndpoints.GetAllPerformanceStandardsMeasuresDisputeInfo:ApiEndpoints.GetAllPerformanceStandardsMeasuresInfo
      const response = await httpService.get<PerformanceArea[]>(
        `${performanceAreaUrl}/${reviewYear}/${mpiId}?tierCode=${providerAppliedTier}`
      );
      let tierData = groupDataByTier(response.data);
      let activeTierData = tierData.filter(
        (tier) =>
          tier.tierCode?.toLowerCase() === providerAppliedTier?.toLowerCase()
      )[0];
      setPerformanceAreas(activeTierData.performanceAreas);
      setAppliedTierId(activeTierData.tierId);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching performance area info:", error);
      setLoading(false);
    }
  };

  const groupDataByTier = (data: any[]): TierQuestions[] => {
    // Object.create(null) prevents prototype pollution via __proto__ / constructor keys
    const tierMap: { [key: number]: TierQuestions } = Object.create(null);
    data.forEach((item) => {
      const {
        tierId,
        tierName,
        tierCode,
        performanceAreaId,
        performanceAreaTitle,
        performanceAreaDescription,
        standardId,
        standardTitle,
        standardDescription,
        measureId,
        measureTitle,
        measureDescription,
        measureNumber,
        reviewResponse,
        hasReason,
        isReadOnly,
        reviewResponseId,
        isCalculatedField,
        questionId,
        questionTitle,
        questionDescription,
        isReviewed,
        fieldName,
        fieldValue,
        dataFieldType,
        dataSource,
        hasValidThreshold,
        questionSequence,
        questionNumber,
        propertySequence,
        displayConfig,
        recommendedStatus,
        comment,
        attachments,
        isEnabledForSme,
        isSmeInvolved
      } = item;

      // Validate tierId is a safe positive integer to prevent prototype pollution
      const safeTierId = Number(tierId);
      if (!Number.isFinite(safeTierId) || !Number.isInteger(safeTierId) || safeTierId <= 0) return;

      // If the tier doesn't exist, create it
      if (!tierMap[safeTierId]) {
        tierMap[safeTierId] = {
          tierId: safeTierId,
          tierName,
          tierCode,
          performanceAreas: [],
        };
      }
      //
      // Add performance area to the tier
      if (!tierMap[safeTierId].performanceAreas) {
        tierMap[safeTierId].performanceAreas = [];
      }

      let performanceArea = tierMap[safeTierId].performanceAreas.find(
        (pa) => pa.performanceAreaId === performanceAreaId
      );
      if (!performanceArea) {
        performanceArea = {
          performanceAreaId,
          performanceAreaTitle,
          performanceAreaDescription,
          standards: [],
        };
        tierMap[safeTierId].performanceAreas.push(performanceArea);
      }

      // Add standard to the performance area
      let standard = performanceArea.standards.find(
        (s) => s.standardId === standardId
      );
      if (!standard) {
        standard = {
          standardId,
          standardTitle,
          standardDescription,
          isLocationSpecific: item.isLocationSpecific,
          tierId: safeTierId,
          tierName,
          measures: [],
        };
        performanceArea.standards.push(standard);
      }

      // Add measure to the standard
      let measure = standard.measures.find((m) => m.measureId == measureId);
      if (!measure) {
        const commentAvailable =
          allCommentData.filter((c) => c.measureId === measureId).length > 0;
        measure = {
          measureId,
          measureTitle,
          measureDescription,
          measureNumber,
          reviewResponse,
          hasReasons: hasReason,
          isReadOnly:isReadOnly,
          reviewResponseId: reviewResponse ? reviewResponseId : null,
          questions: [],
          isCommentsAvailable: commentAvailable,
          recommendedStatus,
          isEnabledForSme: isEnabledForSme === true, // Set initially if present in this row
          isSmeInvolved: isSmeInvolved === true
        };
        standard.measures.push(measure);
      }
      // If any question for this measure has isEnabledForSme true, set it at measure level
      if (isEnabledForSme === true) {
        measure.isEnabledForSme = true;
      }
      // If any question for this measure has isSmeInvolved true, set it at measure level
      if (isSmeInvolved === true) {
        measure.isSmeInvolved = true;
      }

      let question = measure.questions.find((q) => q.questionId === questionId);
      if (!question) {
        question = {
          questionId,
          questionTitle,
          questionDescription,
          questionSequence: questionSequence,
          questionNumber: questionNumber,
          dataFieldType,
          isReviewed,
          dataSource,
          reviewResponseId: isReviewed ? reviewResponseId : null,
          isCalculatedField,
          comment,
          attachments:attachments?JSON.parse(attachments):attachments,
          displayConfig: displayConfig
            ? JSON.parse(displayConfig)
            : displayConfig,
          responseData: [],
        };

        measure.questions.push(question);
      }

      question.responseData.push({
        fieldName,
        fieldValue,
        hasValidThreshold,
        propertySequence,
      });
    });
    return Object.values(tierMap);
  };

  const canDisable = useCallback(() => {
    return (
      //isAdministrator() ||
      selectedStatus?.statusCode?.toLowerCase() ==
        ReviewStatusCode.NotStarted?.toLowerCase() ||
      selectedStatus?.statusCode?.toLowerCase() ==
        ReviewStatusCode.ScoNotStarted?.toLowerCase() ||
      provider?.reviewStatusId == 0 ||
      selectedStatus?.statusCode?.toLowerCase() ==
        ReviewStatusCode.ScoReviewCompleted?.toLowerCase() ||
         selectedStatus?.statusCode?.toLowerCase() ==
        ReviewStatusCode.ScoResolutionReviewCompleted?.toLowerCase() ||
        selectedStatus?.statusCode?.toLowerCase() ==
        ReviewStatusCode.ScoResolutionNotStarted?.toLowerCase() ||
      canDisableStatusRelatedInputs()
    );
  }, [selectedStatus, provider?.reviewStatusId, canDisableStatusRelatedInputs]);

  const hasUnReviewedMeasures = (): boolean => {
    const hasunreviewedMeasures = performanceAreas.reduce((acc, area) => {
      return (
        acc +
        area.standards.reduce((acc, standard) => {
          return (
            acc +
            standard.measures.filter(
              (measure) =>
                measure.reviewResponse === null ||
                measure.reviewResponse?.toLowerCase() === "null" ||
                measure.reviewResponse?.toLowerCase() === "nr"
            ).length
          );
        }, 0)
      );
    }, 0);
    return hasunreviewedMeasures > 0;
  };

  const renderStandardsSection = (standards: Standard[]) => {
    return (
      <>
        {[...(standards || [])]
          .sort((a, b) => a?.standardTitle.localeCompare(b?.standardTitle))
          .map((standard: Standard) => (
            <StandardsDetailsComponent
              downLoadProviderDataByDataSource={
                downLoadProviderDataByDataSource
              }
              key={`${standard.standardId}-${isActiveReview && !canDisable()}`}
              isEnabled={isActiveReview && !canDisable()}
              standard={standard}
              dialogRef={dialogRef}
              onReviewChange={onReviewChange}
              updatePerformanceAreasForComments={
                updatePerformanceAreasForComments
              }
              providerAgencyName={provider?.providerAgencyName}
              evaluationStatuses={[...measureEvaluationStatuses]}
              mpi={provider?.mpi}
              canDisableDropdown={(isActiveDisputeReview && !hasDisputeQuestion([standard]))}
              CanShowDisputeIcon={(isActiveDisputeReview && hasDisputeQuestion([standard]))}
              isActiveDisputeReview={isActiveDisputeReview}
              isActiveReview={isActiveReview}
              reviewStatusCode={provider?.reviewStatusCode}
              reviewYear={reviewYear}
              providerType={ProviderType.SCO}
            />
          ))}
      </>
    );
  };

  const getPAEvaluationStatusCounts = (area: PerformanceArea) => {
    let statuses = [...measureEvaluationStatuses];

    let counts = statuses
      .filter((s) => s.canShowStatus)
      .map((status) => {
        return {
          ...status,
          count: area.standards.reduce((acc, standard) => {
            return (
              acc +
              standard.measures.filter((measure) => {
                if (status.code === "null" || status.code?.toLowerCase() === "nr") {
                  return (
                    measure.reviewResponse === null ||
                    measure.reviewResponse === undefined ||
                    measure.reviewResponse === "" ||
                    (typeof measure.reviewResponse === "string" &&
                      (
                        measure.reviewResponse?.trim().toLowerCase() === "null"
                        || measure.reviewResponse?.trim().toLowerCase() === "nr"
                    ))
                  );
                }
                return (
                  measure.reviewResponse &&
                  measure.reviewResponse?.toLowerCase() ===
                    status.code?.toLowerCase()
                );
              }).length
            );
          }, 0),
        };
      });
    // Total measures per status (not used for display, just for total count)
    const totalMeasuresCount = area.standards.reduce(
      (acc, standard) => acc + standard.measures.length,
      0
    );

    return (
      <span style={{ marginLeft: 8 }}>
        <Badge
          value={`Total Measures: ${totalMeasuresCount}`}
          severity="info"
        />
        {counts.map((status) => (
          <Badge
            key={status.code}
            value={`${status.name} Measures: ${status.count}`}
            severity={
              status.code === status.name
                ? "info"
                : status.code === "a"
                ? "success"
                : "warning"
            }
            className="ml-2"
          />
        ))}
      </span>
    );
  };

  const renderProviderAdditionalInfo = () => {
    const data = [providerAdditionalInfo];
    return (
      <div>
        <DataTable value={data}>
          {Object.keys(providerAdditionalInfo).map((key) => (
            <Column key={key} field={key} header={key} />
          ))}
        </DataTable>
      </div>
    );
  };

  const perfromanceAreaTabHeader = (area: PerformanceArea) => {
    const getIsCommentAvailable = (standards: Standard[]): boolean => {
      let isComments: boolean = false;
      standards.forEach((std) =>
        std.measures.forEach((measure) => {
          if (measure.isCommentsAvailable) {
            isComments = true;
          }
        })
      );
      return isComments;
    };


const hasJustificationReasons = (standards: Standard[]): boolean => {
      let hasReasons: boolean = false;
      standards.forEach((std) =>
        std.measures.forEach((measure) => {
          if ( measure.reviewResponse?.toLowerCase() === "na") {
            hasReasons = true;
            return hasReasons
          }
        })
      );
      return hasReasons;
    };
    return (
      <div className="d-flex">
        <div
          className="d-flex"
          style={{ flexGrow: "1", justifyContent: "space-between" }}
        >
          <Tooltip target={"#pa-" + area.performanceAreaId} />
          <div
            data-pr-tooltip={area.performanceAreaTitle}
            data-pr-position="left"
            data-pr-at="right top-20"
            data-pr-my="center"
            id={area.performanceAreaId.toString()}
            className={""}
          >
            <div
              style={{
                display: "inline-block",
                maxWidth: "100ch",
                lineHeight: "2",
                textOverflow: "ellipsis",
              }}
            >
              {area.performanceAreaTitle}
              {": "}
              {area.performanceAreaDescription}
            </div>
            <span style={{ marginLeft: 8 }}>
              {hasDisputeQuestion(area.standards) ? (
                <i
                  className="pi pi-flag-fill"
                  style={{ width: "20px", paddingTop: "5px", color: 'red', fontSize: '1.2rem' }}
                  title="Dispute Performance Area"
                ></i>
              ) : ""}
              <Tooltip target=".pi-exclamation-circle" />
            </span>
          </div>
          {getPAEvaluationStatusCounts(area)}
        </div>
        <div>
          {hasJustificationReasons(area.standards) ? (
            <i
              className="pi pi-comments measure-not-approved-icon"
              style={{ width: "20px", paddingTop: "5px" }}
              title="Fail Reason"
            ></i>
          ) :""}
        </div>
        <div>
          {getIsCommentAvailable(area.standards) ? (
            <i
              className={"pi pi-comments"}
              style={{ width: "20px", paddingTop: "5px" }}
              title="Comments"
            ></i>
          ) : (
            <i className="pi" style={{ width: "20px", paddingTop: "5px" }}></i>
          )}
        </div>
      </div>
    );
  };

  const hasDisputeQuestion = (standards: Standard[]) => {
    let hasDisputeRaised: boolean = false;
    hasDisputeRaised = standards.some(
      s => s.measures.some(
        m => m.questions.some(
          q => !!q.comment || (Array.isArray(q.attachments) && q.attachments.length > 0)
        )
      )
    );
    return hasDisputeRaised;
  }
  const getTotalMeasures = () => {
    const totalMeasures = performanceAreas.reduce((acc, area) => {
      return (
        acc +
        area.standards.reduce((acc, standard) => {
          return acc + standard.measures.length;
        }, 0)
      );
    }, 0);
    return totalMeasures;
  };

  const getApprovalPercentage = () => {
    const totalMeasures = performanceAreas.reduce((acc, area) => {
      return (
        acc +
        area.standards.reduce((acc, standard) => {
          return acc + standard.measures.length;
        }, 0)
      );
    }, 0);

    const approvedMeasures = performanceAreas.reduce((acc, area) => {
      return (
        acc +
        area.standards.reduce((acc, standard) => {
          return (
            acc +
            standard.measures.filter(
              (measure) =>
                measure.reviewResponse &&
                measure.reviewResponse?.toLowerCase() != "null"
            ).length
          );
        }, 0)
      );
    }, 0);

    const approvalPercentage =
      totalMeasures > 0 ? (approvedMeasures / totalMeasures) * 100 : 0;
    return `${approvalPercentage.toFixed(2)}% Measures Reviewed`;
  };

  const getCountByStatus = (statusCode: string) => {
    return performanceAreas
      .flatMap((area) =>
        area.standards.flatMap((standard) => standard.measures)
      )
      .filter((measure) => {
        if (statusCode === "null") {
          return (
            !measure.reviewResponse ||
            measure.reviewResponse?.trim().toLowerCase() === "null"
          );
        }
        return (
          measure.reviewResponse?.toLowerCase() === statusCode.toLowerCase()
        );
      }).length;
  };

  const renderEvaluationStatusByReview = () => {
    const statuses = [...measureEvaluationStatuses];

    return (
      <div>
        <Badge
          key={"Total Measures"}
          value={`Total Measures : ${getTotalMeasures()}`}
          severity={"info"}
          className="ml-2"
        />

        {statuses &&
          statuses.length > 0 &&
          [...statuses]
            .sort((a, b) => a.name.localeCompare(b.name))
            .filter((status) => status.canShowStatus)
            .map((status) => (
              <Badge
                key={status.code}
                value={`${status.name} Measures : ${getCountByStatus(
                  status.code
                )}`}
                severity={
                  status.code === status.name
                    ? "info"
                    : status.code === "a"
                    ? "success"
                    : "warning"
                }
                className="ml-2"
              />
            ))}
      </div>
    );
  };

  // Main Accordion for Performance Areas
  const renderPerformanceAreasAccordion = () => {
    return (
      <>
        <div>
          <div className="evaluation-info-container">
            <h3>
              <span className="section-title">Performance Evaluation</span>

              <Badge
                value={getApprovalPercentage()}
                severity={
                  getApprovalPercentage()?.includes("100") ? "success" : "info"
                }
                className="ml-2"
              />
            </h3>

            {renderEvaluationStatusByReview()}
          </div>
          <Accordion>
            {performanceAreas
              .sort((a, b) =>
                alphaNumericSort(
                  a.performanceAreaTitle,
                  b?.performanceAreaTitle
                )
              )
              .map((area) => (
                <AccordionTab
                  key={area.performanceAreaTitle}
                  header={perfromanceAreaTabHeader(area)}
                  headerClassName={hasDisputeQuestion(area.standards) ? 'dispute-accordion-header' : ''}
                >
                  {renderStandardsSection(area.standards)}
                </AccordionTab>
              ))}
          </Accordion>
        </div>
      </>
    );
  };

  // Callback function for successful file upload
  const handleUploadSuccess = () => {
    setUploadStatus("File uploaded successfully");
    setFileUploaded(true); // Trigger file upload state change
  };

  const renderTierView = () => {
    return (
      <div className="tier-view-accordion">
        {loading ? (
          <p>Loading performance areas...</p>
        ) : (
          renderPerformanceAreasAccordion()
        )}
      </div>
    );
  };

  const downloadDataFile = (fileName: any, providerId: any) => {
    const safeProviderId = Number(providerId);
    if (!safeProviderId || !Number.isInteger(safeProviderId) || safeProviderId <= 0) {
      console.error("Invalid provider ID");
      return;
    }
    httpService
      .get(
        `${ApiEndpoints.DownloadSupportingDataFile}/${safeProviderId}/${encodeURIComponent(String(fileName))}?reviewYear=${encodeURIComponent(String(reviewYear))}`
      )
      .then((response: any) => {
        if (response) {
          console.log("response", response);
          let url = response.data.url;
          const validatedUrl = new URL(url);
          if (
            validatedUrl.protocol === "http:" ||
            validatedUrl.protocol === "https:"
          ) {
            const anchor = document.createElement("a");
            anchor.href = validatedUrl.toString();
            anchor.target = "_blank";
            anchor.click();
          }
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
        setShowConfirmDialog(true);
      })
      .finally(() => {
        //setShowConfirmDialog(false);
      });
  };
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const hideDialog = () => {
    setShowConfirmDialog(false);
  };
  const StartReview = () => {
    httpService
      .get(`${ApiEndpoints.StartReview}/${reviewYear}/${provider.mpi}`)
      .then((response: any) => {
        if (response) {
          console.log("response", response);
          setCanStartReview(false);
          getReviewersDetails(provider.mpi);
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      });
  };
  const renderReviewersDetails = () => {
    return reviewers && reviewers.length > 0 ? (
      <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
        <ReviewersDetailsComponent reviewers={reviewers} />
      </div>
    ) : null;
  };
  return (
    <div className="provider-profile-file-upload">
      {provider && (
        <div
          style={{ display: "flex", flexDirection: "row", columnGap: "2rem" }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className="flex-gap-bottom">
              <span className="tag-key">Agency Name :</span>
              {provider?.providerAgencyName?.length > 40 ? (
                <>
                  <span
                    className="tag-value agency-name-ellipsis"
                    data-pr-tooltip={provider?.providerAgencyName}
                  >
                    {" "}
                    {provider?.providerAgencyName}
                  </span>{" "}
                  <Tooltip target=".agency-name-ellipsis" />
                </>
              ) : (
                <span className="tag-value">
                  {" "}
                  {provider?.providerAgencyName}
                </span>
              )}
              <span className="tag-key">MPI: </span>
              <span className="tag-value"> {provider.mpi}</span>
            </div>
            <div className="flex-gap-bottom">
              <span className="tag-key">Review Status :</span>
              {status.length > 0 && (
                <Dropdown
                  disabled={
                    updatingStatus ||
                    !isActiveReview ||
                     (isAdministrator() && (
                        selectedStatus?.statusCode?.toLowerCase() === ReviewStatusCode.ScoReviewCompleted?.toLowerCase() ||
                        selectedStatus?.statusCode?.toLowerCase() === ReviewStatusCode.ScoResolutionReviewCompleted?.toLowerCase()
                      )) ||
                    canDisableStatusRelatedInputs()
                  }
                  value={selectedStatus}
                  onChange={(e: DropdownChangeEvent) =>
                    setReviewStatus(e.value)
                  }
                  options={status.sort((a, b) =>
                    a.statusName.localeCompare(b.statusName)
                  )}
                  optionLabel="statusName"
                  placeholder={provider.reviewStatus}
                />
              )}
              {updatingStatus && (
                <i 
                  className="pi pi-spin pi-spinner" 
                  style={{ fontSize: '1.2em', marginLeft: '8px' }}
                ></i>
              )}
              {canStartReview && status.length > 0 && (
                <Button
                  label="Start Review"
                  className="ml-2"
                  onClick={() => StartReview()}
                />
              )}
            </div>
            <div className="flex-gap-bottom">
              <span className="tag-key">Outcome Status : </span>
              <span className="tag-value">
                {" "}
                {(isFinalReviewer() || isAdministrator()) && isCalculate ? (
                  <div>
                    <i
                      className="pi pi-spin pi-spinner"
                      style={{ fontSize: "1.2em", marginRight: "8px" }}
                    />
                    Calculating...
                  </div>
                ) : (
                  calculatedTier || provider.currentTier
                )}
              </span>
            </div>
          </div>
          <div>
            {reviewers && reviewers.length > 0 && renderReviewersDetails()}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginLeft: "auto",
            }}
          >
            <Button
              size="small"
              className="p-button-secondary"
              disabled={!isActiveReview}
              onClick={() => setSidebarVisible(!sidebarVisible)}
              style={{ marginRight: "15px" }}
            >
              Comment
            </Button>
            <Button
              size="small"
              disabled={isAdministrator() || canDisableStatusRelatedInputs()}
              className="p-button-secondary"
              onClick={() => setVisible(true)}
              style={{ marginRight: "15px" }}
            >
              Upload File
            </Button>
          </div>
        </div>
      )}
      <Dialog
        header="Upload"
        visible={visible}
        onHide={() => setVisible(false)}
      >
        <div
          className="flex flex-column px-8 py-5 gap-4"
          style={{
            borderRadius: "12px",
            width: "1000px",
            height: "auto",
            minHeight: "300px",
          }}
        >
          {provider.providerId && (
            <MultipartFileUploadComponent
              name="file"
              customUpload
              accept=".pdf,.doc,.docx"
              maxFileSize={1000000}
              auto
              chooseLabel="Choose"
              uploadLabel="Upload"
              cancelLabel="Cancel"
              className="p-mb-3"
              onFileuploaded={() => {
                console.log("file uploaded");
                // Refresh provider details to show the uploaded file immediately
                if (provider && provider.mpi && provider.appliedTierCode) {
                  fetchPerformanceStandardsMeasuresInfo(
                  provider.mpi,
                  provider.appliedTierCode
                  );
                }
              }}
              providerId={provider.mpi}
              providerProfile="ProviderProfile"
              onUpload={handleUploadSuccess}
              onError={() => {
                setUploadStatus("Upload failed. Please try again.");
              }}
            />
          )}
          {uploadStatus && <p>{uploadStatus}</p>}
        </div>
      </Dialog>

      <div>
        <h3>
          <span className="section-title">Contact Information</span>
        </h3>
        {loading ? (
          <p>Loading provider details...</p>
        ) : (
          <DataTable value={[provider]} paginator={false}>
            <Column field="firstName" header="First Name" />
            <Column field="lastName" header="Last Name" />
            <Column field="telephoneNumber" header="Phone Number" />
            <Column
              field="emailAddress"
              header="Email Address"
              body={(rowData) => (
                <a href={`mailto:${rowData.emailAddress}`}>
                  {rowData.emailAddress}
                </a>
              )}
            />
          </DataTable>
        )}
        <br></br>
      </div>
      {provider.attestationFile ? (
        <div className="attestation-button-wrapper">
          <Button
            onClick={() => {
              downloadDataFile(provider.attestationFile, provider?.mpi);
            }}
            icon="pi pi-download"
            className="p-button-secondary"
          >
            &nbsp;{provider.attestationFile}
            {/*"Download Attestation File"*/}
          </Button>
        </div>
      ) : (
        <></>
      )}
      {providerAdditionalInfo &&
        Object.keys(providerAdditionalInfo).length > 0 &&
        renderProviderAdditionalInfo()}

      <div>{renderTierView()}</div>
      <Dialog
        header="File not found!"
        visible={showConfirmDialog}
        onHide={hideDialog}
        footer={
          <div style={{ display: "flex", justifyContent: "end" }}>
            <Button
              label="Close"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={hideDialog}
              autoFocus
            />
          </div>
        }
      >
        <div>
          <p>{Constants.FILE_NOT_FOUND_ERROR}</p>
        </div>
      </Dialog>
      {sidebarVisible && (
        <CommentsSidebar
          {...{
            sidebarVisible,
            handleCommentsSidebarHide: () => setSidebarVisible(false),
            commentProviderMPI,
            commentMeasureId,
            commentMeasureNumber,
            commentLevel,
            updatePerformanceAreasForComments,
            providerAgencyName: provider?.providerAgencyName,
            externalSave: () => {},
            providerType: ProviderType.SCO
          }}
        />
      )}
      <CommonDialogWindowComponent ref={dialogRef} />
      <Toast ref={toast} />
    </div>
  );
};

export default ScoProviderProfileComponent;